import "./styles";
import RouterProvider from "./Router";

const App = () => {
  return <RouterProvider />;
};

export default App;
